var PhoneVerificationEvents;
(function (PhoneVerificationEvents) {
    PhoneVerificationEvents["CLOSE"] = "close";
})(PhoneVerificationEvents || (PhoneVerificationEvents = {}));

export { PhoneVerificationEvents };
